import { mapActions } from 'vuex';
import currentSubsidiaryStorage from '@/shared/current-subsidiary';

function created() {
	const breadCrumbs = JSON.parse(localStorage.getItem('bc'));
	if (breadCrumbs) {
		this.$updateBreadCrumbsFromLocalStorage(breadCrumbs);
	}
	// Empresa elegida por este usuario; se valida contra su lista al cargar la cabecera.
	const currentSubsidiary = currentSubsidiaryStorage.read();
	if (currentSubsidiary) {
		this.$setCurrentSubsidiary(currentSubsidiary);
	}
}

export default {
	created,
	methods: {
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
		}),
		...mapActions('route', {
			$updateBreadCrumbsFromLocalStorage: 'LOCAL_STORAGE_BREAD_CRUMBS',
		}),
	},
};



// WEBPACK FOOTER //
// ./src/mixins/updateOnReload.js